import React from 'react'
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { useGetPermissions } from 'layouts/customHook';
import ExamPayRate from './ExamPayRate';

const ExamPayRateSlab = () => {
    const userPermissions = useGetPermissions('examPayRateMaster');
    return userPermissions ? <ExamPayRate userPermissions={userPermissions} /> : <PermisionDenied />
}

export default ExamPayRateSlab;